<script setup>
import { defineProps } from 'vue';
import { Head } from '@inertiajs/inertia-vue3';
import HeaderPadrao from '../Componentes/Cabecalho/Padrao';
import { useDialogos } from '../Composables/useDialogos';
import AlertaAnalise from '../Componentes/AlertaAnalise';
import Rodape from '../Componentes/Rodape';
import ReportaErros from '../Componentes/ReportaErros';
import useGlobals from '../Composables/useGlobals';

useDialogos();

const {
    nomeLeiloeiro
} = useGlobals();

defineProps({
    title: String,
    description: String,
});

</script>

<template>
    <Head>
        <title>{{(title ? (title + ' - ' ) : '') + nomeLeiloeiro}}</title>
        <meta name="description" :content="description">
    </Head>
    <q-layout view="hHh lpR fFf">
        <reporta-erros>
            <HeaderPadrao class="hide-print" />
        </reporta-erros>
        <q-page-container>
            <reporta-erros>
                <slot></slot>
                <alerta-analise />
                <rodape />
            </reporta-erros>
        </q-page-container>
    </q-layout>
</template>
